// @core/api/endpoints/tenant/get_tenant_analytics.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantAnalyticsResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant analytics summary
 * Returns aggregated activity, engagement, and usage metrics across all products for the specified time period. Includes member activity, API usage, storage consumption, and financial metrics.
 */
export async function GetTenantAnalytics(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantAnalyticsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/analytics`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantAnalyticsResponse>(requestPath, { ...requestOptions });
}
